/**
 * StaffPicks Component
 */

import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import TrackListItem from '../../../molecules/search/TrackListItem';
import SectionTitle from '../SectionTitle';

interface IStaffPicksProps {
  tracks: GQL.ITrackSearchResult[];
  withBackground?: boolean;
}

const classes = new BEM('staff-picks');

const StaffPicks: React.SFC<IStaffPicksProps> = ({ tracks, withBackground }) => {
  const classModifiers = {
    'with-background': !!withBackground,
  };

  return (
    <div {...classes('', classModifiers) }>
      {withBackground && (
        <div
          style={{
            backgroundImage: `url(https://orpheus-assets.s3.amazonaws.com/images/eric-nopanen-208576-unsplash.jpg)`,
          }}
          {...classes('background') }
        />
      )}
      <div {...classes('content-wrapper', '', 'container') }>
        <SectionTitle
          title="New &amp; Noteworthy"
          textColor={withBackground ? 'white' : undefined}
          {...classes('title') }
        />
        <ul {...classes('track-list') }>
          {tracks.map((track) => (
            <TrackListItem
              actionSource="featured_tracks_list"
              key={track.id}
              track={track}
              cardProps={{
                backgroundColor: 'white',
              }}
              {...classes('track-list__item')}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default StaffPicks;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/StaffPicks/index.tsx